import React, { Component } from 'react';
import { Alert, Button, Card, CardBody, CardHeader, CardTitle, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { DataGrid } from '../../components/ui/DataGrid';
import { userData } from '../../util/userData';
import { IRankingReport } from '../RankingReportCreationContainer/lib/interfaces';
import { deleteReport, getReports, verifyIfAdmin } from './lib/https';
import { containerProps, containerState } from './lib/interfaces';
import { openRankingReport } from './lib/utils';

export class RankingReportContainer extends Component<containerProps, containerState> {
  state: containerState = {
    reports: [],
    deleteWarningModalOpen: false,
    selectedReportCreatorUsername: '',
    selectedReportColumns: [],
    requestedAvids: [],
    exportUrl: '',
    userId: undefined,
    isAdmin: false,
    deleteModalWarningText: '',
    grantDeleteOption: false,
    reportIdToBeDeleted: undefined
  }

  componentDidMount() {
    this.getReportsList();
    this.setUserId();
  }

  setUserId() {
    userData.getUserId().then((id) => {
      this.setState({ userId: id })
      verifyIfAdmin(id).then((isAdmin) => {
        this.setState({ isAdmin })
      })
    })
  }

  getReportsList() {
    getReports(0).then((res) => {
      this.setState({ reports: res });
    })
  }

  /**
   * Opens the Creation Page
   * TODO
   */
  createNewReport() {
    console.log('new');
    return false;
  }

  /**
   * Opens report in edit mode
   * @param reportID
   * TODO
   */
  editReport(reportID: number) {
    console.log('edit');
    return false;
  }

  /**
   * Shows the results of the saved reports in the Report Page
   * @param reportID
   * TODO
   */
  runReport(reportID: number) {

  }

  /**
   * Mark report as deleted
   * @param record
   */
  startDeleteReportWorkflow(record: IRankingReport) {
    const { userId, isAdmin } = this.state;
    if (record.created_by === userId || isAdmin) {
      this.setState({
        deleteWarningModalOpen: true,
        deleteModalWarningText: `Are you sure you want to permanently delete the following ranking report: ${record.name ? record.name : ''}`,
        grantDeleteOption: true,
        selectedReportCreatorUsername: record.createdByUsername ? record.createdByUsername : '',
        reportIdToBeDeleted: record.id
      })
    } else {
      this.setState({
        deleteWarningModalOpen: true,
        deleteModalWarningText: `You are not authorized to delete this report. Please contact ${record.createdByUsername ? record.createdByUsername : ''} to delete it.`,
        grantDeleteOption: false,
        selectedReportCreatorUsername: record.createdByUsername ? record.createdByUsername : '',
      })
    }
  }

  deleteReport(recordId: number) {
    deleteReport(recordId).then((res) => {
      if (res) {
        const updatedReportList = this.state.reports.filter(r => r.id !== recordId);
        this.setState({ reports: updatedReportList })
      }
    })
  }

  getDownloadLink(url: string) {
    this.setState({ exportUrl: url })
  }

  render() {
    const {
      reports,
      deleteWarningModalOpen,
      selectedReportCreatorUsername,
      deleteModalWarningText,
      grantDeleteOption,
      reportIdToBeDeleted,
    } = this.state;

    return (
      <div>
        <Card>
          <CardHeader className="bg-white">
            <CardTitle className="d-flex justify-content-between">
              List of Reports
              <a
                href={`/rankingReportCreation`}
                className="btn btn-primary "
                role="button"
                style={{ textTransform: "none" }}
              >
                Create New Report
              </a>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <DataGrid
              hideInputs={!(reports.length > 10)}
              records={reports}
              columns={[
                { header: "Report Name", property: "name" },
                { header: "Last Saved", property: "lastSaved" },
                {
                  header: "",
                  render: (record) => {
                    return (
                      <a
                        href={`/rankingReportCreation?report_id=${record.id}`}
                        className="btn btn-primary lighten-2 white-text btn-block"
                        role="button"
                        style={{ textTransform: "none" }}
                      >
                        Edit
                      </a>
                    );
                  },
                },
                {
                  header: "",
                  render: (record) => {
                    return (
                      <Button
                        color="primary"
                        block
                        onClick={() => openRankingReport(record.id)}
                      >
                        Run
                      </Button>
                    );
                  },
                },
                {
                  header: "",
                  render: (record) => {
                    return (
                      <Button
                        color="danger"
                        block
                        onClick={() => this.startDeleteReportWorkflow(record)}
                      >
                        Delete
                      </Button>
                    );
                  },
                },
              ]}
            />
          </CardBody>
        </Card>
        <Modal
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={
            deleteWarningModalOpen && selectedReportCreatorUsername.length > 0
          }
        >
          <ModalBody>
            <Alert color={"warning"}>{deleteModalWarningText}</Alert>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                this.setState({
                  deleteWarningModalOpen: false,
                  selectedReportCreatorUsername: "",
                });
              }}
            >
              {grantDeleteOption ? 'Cancel' : 'Close'}
            </Button>
            {grantDeleteOption && (
              <Button
                color="primary"
                onClick={() => {
                  this.setState({
                    deleteWarningModalOpen: false,
                    selectedReportCreatorUsername: "",
                  }, () => {
                    this.deleteReport(reportIdToBeDeleted)
                    this.setState({ reportIdToBeDeleted: undefined })
                  });
                }}
              >
                Ok
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
